import { SAMOLET_LK_HOST, SAMOLET_LK_LOCAL_HOST, SAMOLET_LK_STAGE_HOST } from '../../../../constants/common';
import { getEnvironment } from '../../../../utils/getEnvironment';
export var getLkWsHost = function () {
    var _a = getEnvironment(), isStage = _a.isStage, isLocalhost = _a.isLocalhost, isProd = _a.isProd;
    var host = (isProd && SAMOLET_LK_HOST) || (isStage && SAMOLET_LK_STAGE_HOST) || (isLocalhost && SAMOLET_LK_LOCAL_HOST);
    var protocol = isProd || isStage ? 'wss' : 'ws';
    return protocol + "://" + host;
};
//# sourceMappingURL=getLkWsHost.js.map